import type { TimelineProperties } from './TimelineLayout';
import { CAMERA_TRACK_LIMITS } from '../../domain/camera-keyframes';
import { SCENE_TRACK_LABELS } from './TimelineSceneTracks';
import { sceneKeyframeSummary } from '../scene-keyframe-summary';
import { TimelineTimecode } from './TimelineTimecode';

export function TimelineKeySelection(props: Pick<TimelineProperties, 'attributes' | 'waypoints' | 'selectedWaypoint' | 'selectedSceneProperty' | 'duration' | 'onScenePropertySelect' | 'onWaypoint' | 'onMoveWaypoint' | 'onDeleteWaypoint' | 'onEditKey'>) {
  const last = props.duration * 30 - 1;
  const camera = props.attributes?.selected;
  const cameraKey = camera && props.attributes?.tracks?.[camera.axis]?.find((key, index) => (key.id ?? String(index)) === camera.id);
  const scene = props.waypoints.find(item => item.waypoint.id === props.selectedWaypoint);
  const property = props.selectedSceneProperty;
  const selection = camera && cameraKey ? {
    label: CAMERA_TRACK_LIMITS[camera.axis].label, seconds: cameraKey.seconds,
    value: cameraKey.automatic ? 'Automatic' : `${Number(cameraKey.value.toFixed(2))} ${CAMERA_TRACK_LIMITS[camera.axis].unit}`,
    edit: () => props.attributes?.onSelect(camera.axis, camera.id),
    move: (seconds: number) => props.attributes?.onPatch(camera.axis, camera.id, { seconds }),
    remove: () => props.attributes?.onDelete(camera.axis, camera.id),
  } : scene && property && scene.waypoint.overrides[property] !== undefined ? {
    label: SCENE_TRACK_LABELS[property], seconds: scene.seconds,
    value: sceneKeyframeSummary({ [property]: scene.waypoint.overrides[property] }),
    edit: () => props.onScenePropertySelect ? props.onScenePropertySelect(scene.waypoint.id, property) : props.onWaypoint(scene.waypoint.id),
    move: (seconds: number) => props.onMoveWaypoint(scene.waypoint.id, seconds, property),
    remove: () => props.onDeleteWaypoint(scene.waypoint.id, property),
  } : null;
  return <div className="timeline-key-editing">
    {selection && <div className="timeline-key-selection" role="group" aria-label="Selected keyframe">
      <strong>{selection.label} key</strong><span className="timeline-key-value">{selection.value}</span>
      <TimelineTimecode label="Selected key time" frame={Math.round(selection.seconds / props.duration * last)} last={last}
        onChange={frame => selection.move(frame / last * props.duration)} />
      <button type="button" onClick={() => { selection.edit(); props.onEditKey?.(); }}>Edit value</button>
      <button type="button" onClick={selection.remove}>Delete key</button>
    </div>}
    <p className="timeline-key-help">Drag a diamond to move a key. Drag the bar’s handle to change its duration. Select a key to edit its value.</p>
  </div>;
}
